import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

import { SnPublicity } from '../../../enums';

// TODO Migrate to form generator
@Component({
  selector: 'sn-edit-organization-form',
  templateUrl: './edit-organization-form.component.html',
  styleUrls: ['./edit-organization-form.component.scss'],
})
export class SnEditOrganizationFormComponent {
  @Input()
  public isLoading = false;

  @Input()
  set name(name: string) {
    this.nameControl.setValue(name);
  }

  @Input()
  set publicity(publicity: SnPublicity) {
    const isPublic = publicity === SnPublicity.Public;
    this.publicityControl.setValue(isPublic);
  }

  @Input()
  set hideSystemNotifications(value: boolean) {
    this.hideSystemNotificationsControl.patchValue(value);
  }

  @Output()
  public readonly send = new EventEmitter<Object>();

  public form: UntypedFormGroup;

  constructor(
    private readonly _formBuilder: UntypedFormBuilder,
    private readonly _matDialogRef: MatDialogRef<SnEditOrganizationFormComponent>,
  ) {
    this._initForm();
  }

  get nameControl(): AbstractControl {
    return this.form.get('name');
  }

  get publicityControl(): AbstractControl {
    return this.form.get('publicity');
  }

  get hideSystemNotificationsControl(): AbstractControl {
    return this.form.get('hideSystemNotifications');
  }

  public cancel(): void {
    this._matDialogRef.close();
  }

  public sendFormData(): void {
    const data = this.form.value;
    this.send.emit(data);
  }

  private _initForm(): void {
    this.form = this._formBuilder.group({
      publicity: [true, Validators.required],
      hideSystemNotifications: [false],
      name: ['', Validators.required],
    });
  }
}
